import { WorkflowStatus } from '../../../api/process-client/process-client.type';
import { newCOLORS } from '../../../styles/colors';

/**
 * Retrieves the background color associated with a given workflow status.
 *
 * Lives in a standalone module so the binding survives Linaria's build-time
 * shaking — a function referenced only by a `styled` dynamic interpolation is
 * dropped from the runtime bundle when declared locally, throwing at render.
 *
 * @param {WorkflowStatus} status - The status of the workflow.
 * @returns {string} The background color associated with the given status.
 */
const getBackground = (status: WorkflowStatus): string => {
  const backgrounds = {
    [WorkflowStatus.Backwards]: newCOLORS.white,
    [WorkflowStatus.Skipped]: newCOLORS.purple2,
  } as Record<WorkflowStatus, string>;

  return backgrounds[status];
};

export { getBackground };
